import React, { useContext, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import { useTranslation } from "react-i18next";
import styles from "./Communication.module.css";
import { CommunicationTimeline } from "./CommunicationTimeline";
import { RootStoreContext } from "src/stores/RootStore";
import { getDateWithLongMonth } from "src/utils/Date";
import { Route, selectRoute } from "src/config/routes";
import { useParams, useHistory } from "react-router";

interface Params {
    assemblyid?: string;
}

const CommunicationBase = () => {
    const { navStore, assemblyStore, authStore, communicationStore } = useContext(RootStoreContext);
    const { t } = useTranslation();
    const { assemblyid } = useParams<Params>();
    const history = useHistory();

    useEffect(() => {
        return () => {
            communicationStore.setIsCommunicationStoreInitializing(true);
        };
        // Only run on mount/unmount
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (assemblyStore.currentAssembly) {
            navStore.setTitle(
                `${assemblyStore.currentAssembly?.title} am ${getDateWithLongMonth(
                    assemblyStore.currentAssembly?.date || ""
                )}` || ""
            );
        }

        navStore.setActionButtonMiddle(null);
        navStore.setActionButtonRight(null);
        navStore.setBackbutton(
            selectRoute(Route.assemblies, authStore.user?.role),
            t("screens.assemblies.sidebar_title").toString()
        );
    }, [assemblyStore, authStore, navStore, t, assemblyStore.currentAssembly]);

    useEffect(() => {
        if (assemblyStore.currentAssembly?.livemode) {
            history.push(
                selectRoute(Route.assemblyLiveMode, authStore.user?.role, {
                    assemblyid: assemblyStore.currentAssembly?.id || ""
                })
            );
        }
    }, [assemblyStore.currentAssembly?.livemode, history, authStore.user?.role, assemblyStore.currentAssembly?.id]);

    useEffect(() => {
        if (assemblyid) {
            communicationStore.initAssemblyAndHistory(assemblyid);
            communicationStore.getProtocolOrAgendaitemFile(assemblyid);
        }
    }, [assemblyid, communicationStore]);

    return (
        <UI.Container className={`${styles.Container} pt-4`}>
            <div className={styles.Title}>{t("screens.assemblies.communication")}</div>
            <CommunicationTimeline />
        </UI.Container>
    );
};

export const Communication = Sentry.withProfiler(observer(CommunicationBase));
